// extracted by mini-css-extract-plugin
export const root = "flexible-content-module--root--3WA83";